<div class="modal inmodal fade in parcel-modal create-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title col-sm-8">Courier Type</h4>
                </div>
                <div class="modal-body">
                    <div class="add-time">
                        <input name="newCourierType" placeholder="New Courier Type..." [(ngModel)]="newCourierType">
                        <i class="fa fa-plus-circle mtv-primary-color"
                           [ngStyle]="{'cursor' : !disabledSubmit ? '' : 'not-allowed'}"
                           (click)="addCourierType()"></i>
                    </div>
                    <div [dragula]="'bag-courierTypes'" [dragulaModel]="courierTypes">
                        <div *ngFor="let type of courierTypes; let index = index;"
                             class="couriers-list-item m-b-sm"
                             [ngClass]="{'in-edit-mode': type.editMode, 'disabled-submit': disabledSubmit}">
                            <span *ngIf="!type.editMode">{{type.name}}</span>
                            <span *ngIf="type.editMode">
                                <input name="courierType{{index}}"
                                       id="courierType{{index}}"
                                       [(ngModel)]="type.name"
                                       (change)="somethingWasChanged = true;">
                            </span>
                            <i class="fa fa-trash pull-right" (click)="removeCourierType(index)"></i>
                            <i *ngIf="!type.editMode" class="fa fa-pencil pull-right" (click)="turnEditModeOn(index)"></i>
                            <button *ngIf="type.editMode" type="button" class="close" (click)="type.editMode = false;">
                                <span>×</span><span class="sr-only">Close</span>
                            </button>
                            <i *ngIf="type.editMode" (click)="modifyName(index)" class="fa fa-check pull-right"></i>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="row text-center">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-parcels/courier-type-modal/courier-type-modal.component.html